import React from 'react';

const formatRegionColumnHeader = (label: string): React.ReactNode => {
  const parenthesesIndex = label.indexOf('(');
  if (parenthesesIndex === -1) {
    return label;
  }

  const primaryLabel = label.slice(0, parenthesesIndex).trimEnd();
  const secondaryLabel = label.slice(parenthesesIndex).trim();

  return [
    <span key="main" className="region-header-main">
      {primaryLabel}
    </span>,
    <br key="break" />,
    <span key="suffix" className="region-header-suffix">
      {secondaryLabel}
    </span>,
  ];
};

export default formatRegionColumnHeader;
